import React, { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabaseClient'
import type { AuditLogRow } from '@/lib/types'
import { PageSpinner, Badge } from '@/components/ui'
import { formatDateTime, formatRelative } from '@/lib/format'

export default function ActivityTab({ companyId }: { companyId: string }) {
  const [logs, setLogs] = useState<AuditLogRow[] | null>(null)

  useEffect(() => {
    supabase
      .from('audit_logs')
      .select('*')
      .eq('company_id', companyId)
      .order('created_at', { ascending: false })
      .limit(200)
      .then(({ data }) => setLogs((data as AuditLogRow[]) || []))
  }, [companyId])

  if (logs === null) return <PageSpinner label="Loading activity…" />
  if (logs.length === 0) return <p className="text-sm text-slate-500">No activity recorded yet.</p>

  return (
    <ol className="space-y-3">
      {logs.map((log) => (
        <li key={log.id} className="flex gap-3 border-b border-slate-100 pb-3 text-sm">
          <div className="w-16 shrink-0 text-xs text-slate-400" title={formatDateTime(log.created_at)}>
            {formatRelative(log.created_at)}
          </div>
          <div className="flex flex-1 items-center gap-2">
            <span className="text-slate-700">{log.description}</span>
            <Badge tone={log.actor_type === 'admin' ? 'blue' : log.actor_type === 'company' ? 'green' : 'slate'}>{log.actor_type}</Badge>
          </div>
        </li>
      ))}
    </ol>
  )
}
